import React, {useEffect, useState} from 'react';
import {observer} from "mobx-react";
import {Tab, Tabs} from '@material-ui/core';
import auditDataStore from '../../stores/license/auditDataStore';

const LicenseFormReviewTabs: React.FC<{ onTabChange?: (id: string) => void }> = observer(({onTabChange}) => {
    const [selectedTab, setSelectedTab] = useState(0);

    useEffect(() => {
        const initializeTab = async () => {
            const selectedAuditIndex = auditDataStore.auditData.findIndex(audit => audit.id === auditDataStore.selectedAudit?.id);
            if (selectedAuditIndex !== -1) {
                setSelectedTab(selectedAuditIndex);
            }
            const includeForms = true;
            await auditDataStore.handleTabChange(selectedAuditIndex !== -1 ? selectedAuditIndex : 0, includeForms);
            if (onTabChange) {
                const selectedAudit = auditDataStore.auditData[selectedAuditIndex !== -1 ? selectedAuditIndex : 0];
                if (selectedAudit) {
                    onTabChange(selectedAudit.id);
                }
            }
        };
        initializeTab();
    }, [onTabChange]);

    const handleTabChange = async (_: React.ChangeEvent<{}>, newValue: number) => {
        setSelectedTab(newValue);
        const includeForms = true;
        await auditDataStore.handleTabChange(newValue, includeForms);
        if (onTabChange) {
            const selectedAudit = auditDataStore.auditData[newValue];
            if (selectedAudit) {
                onTabChange(selectedAudit.id);
            }
        }
    };

    return (
        <Tabs value={selectedTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
            {auditDataStore.auditData.map((audit) => (
                <Tab
                    key={audit.id}
                    label={`${new Date(audit.startDate).toLocaleString('default', {
                        month: 'short',
                        year: 'numeric'
                    })}`}
                />
            ))}
        </Tabs>
    );
});

export default LicenseFormReviewTabs;